<template>
  <HrdCloudMobileHeader v-if="!isFullscreen" :show-back="true">
    <template v-slot:right>
      <HrdCloudAtchFile v-if="hrd" :is-mobile="isMobile" :hrd="hrd"/>
    </template>
  </HrdCloudMobileHeader>
  <main class="kb-main" id="kb-hrdcloud">
    <div class="main-content main-component">
      <HrdCloudMobileMode />
      <div class="hrdcloud-view-container">
        <div class="player hrdcloud-player">
          <div class="player-container">
            <div class="player-inner">
              <template v-if="hrd && uuid">
                <HrdCloudPlayer
                    v-if="hrd.lrnObjTyCd === lrnObjTyCds.MP3 || hrd.lrnObjTyCd === lrnObjTyCds.MP4"
                    v-model="videoInstance"
                    v-model:uuid="uuid"
                    v-model:is-series-active="isSeriesActive"
                    :coldcall="coldcall"
                    :crse="hrd"
                    :progress="user"
                    :enable-progress="true"
                    :popups="popups"
                    :show-roadmap-func="showRoadmapPlayList"
                    :is-a-i-practice-enabled="isAIPracticeEnabled"
                    @practicePoint="handlePracticePoint"
                    @praticeComplete="handlePracticeComplete"
                    @toggleFull="toggleFull"
                    @update:videoInstance="(instance) => videoInstance = instance"
                />
              </template>
            </div>
            <HrdMobilePlayerDetails v-if="hrd" :player="videoInstance" :hrd="hrd" :funcs="detailFuncs" />
            <HrdCloudMobileSeriesList v-if="isSeriesActive && hrd && hrd.cttSnLst != null && hrd.cttSnLst.length > 0" :crse="hrd" />
            <HrdCloudRoadmapPlayList v-if="isRoadmapListActive" :crse="hrd" :roadmap-sns="roadmapSns" :close-func="() => {isRoadmapListActive.value = false;}" />
          </div>
        </div>
        <HrdCloudMobileComment v-if="hrd" :effect-nav="effectNav" :objSn="hrd.objSn" />
      </div>
    </div>
  </main>
  <div v-if="hrd" class="popup-container p-0 d-block" id="kb-mobile-popup" :class="{ 'is-active' : showModal }">
    <HrdCloudMobileHistory v-model="historyModal" :title="hrd.objNm" :duration="hrd.cttSz" :items="histories" :lrnObjDtlDistSn="lrnObjDtlDistSn" :ctt-ty-cd-dcd="hrd.cttTyCdDcd" />
    <HrdCloudMobileShare v-if="shareModal" v-model="shareModal" :data="hrd" />
    <HrdCloudMobileOpinion v-model="opinionModal" :cttMstSn="hrd.objSn" :title="hrd.objNm"/>
    <HrdCloudMobileSttModal v-model="sttModal" :title="hrd.objNm"  :item="sttText"  />
  </div>

  <!-- AI 실습 토글 버튼 -->
  <LLMPracticeToggleMobile
      v-if="isAIPracticeEnabled"
      :active="isPracticeModalVisible"
      @toggle="handlePracticeToggle"
      class="ai-practice-toggle-container"
  />

  <transition name="fade-scale">
    <LLMPracticeModalMobile
        v-if="isPracticeModalVisible"
        :visible="isPracticeModalVisible"
        :practicePoint="currentPracticePoint"
        @practice-off="handlePracticeComplete"
        @practice-toggle="handlePracticeToggle" />
  </transition>

</template>
<script>
import HrdCloudMobileHeader from '@/components/hrdcloud/mobile/HrdCloudMobileHeader';
import HrdCloudAtchFile from '@/components/hrdcloud/HrdCloudAtchFile';
import HrdCloudPlayer from '@/components/hrdcloud/HrdCloudPlayer';
import HrdMobilePlayerDetails from '@/components/hrdcloud/mobile/HrdMobilePlayerDetails';
import HrdCloudMobileComment from '@/components/hrdcloud/mobile/HrdCloudMobileComment';
import HrdCloudMobileHistory from '@/components/hrdcloud/mobile/HrdCloudMobileHistory';
import {useStore} from 'vuex';
import {useRoute} from 'vue-router';
import {computed, onBeforeUnmount, onMounted, reactive, ref, watch} from 'vue';
// import {ACT_GET_HRDCLOUD_DETAIL} from '@/store/modules/prep/prep';
import {
  closeAdded,
  closeSubscribed,
  darkMode,
  detailCategoryDisplay,
  disableMyAddChanged,
  generateUUID,
  handleActions,
  lightMode,
  pageView,
  showMain,
} from '@/assets/js/modules/hrd/hrd-common';
import {getFunc} from '@/assets/js/ui.init';
import {ACT_GET_LEARN_PROGRESS} from '@/store/modules/learn/learn';
import {goBack} from '@/assets/js/modules/common/common';
import {initProgressBar, timestampToDateFormat} from '@/assets/js/util';
import HrdCloudMobileShare from '@/components/hrdcloud/mobile/HrdCloudMobileShare';
import HrdCloudMobileOpinion from '@/components/hrdcloud/mobile/HrdCloudMobileOpinion';
import {lrnObjTyCds} from '@/assets/js/modules/learn/learn-common';
import HrdCloudMobileMode from '@/components/hrdcloud/mobile/HrdCloudMobileMode.vue';
import HrdCloudMobileSeriesList from "@/components/hrdcloud/mobile/HrdCloudMobileSeriesList.vue";
import HrdCloudMobileSttModal from "@/components/hrdcloud/mobile/HrdCloudMobileSttModal";
import HrdCloudRoadmapPlayList from "@/components/hrdcloud/HrdCloudRoadmapPlayList";
import {useAlert} from "@/assets/js/modules/common/alert";
import LLMPracticeModalMobile from "@/components/learn/practice/LLMPracticeModalMobile.vue";
import LLMPracticeToggleMobile from "@/components/learn/practice/LLMPracticeToggleMobile.vue";

export default {
  name: 'HrdMobileVod',
  components: {
    LLMPracticeToggleMobile,
    LLMPracticeModalMobile,
    HrdCloudMobileSttModal,
    HrdCloudMobileSeriesList,
    HrdCloudMobileMode,
    HrdCloudMobileOpinion,
    HrdCloudMobileShare,
    HrdCloudMobileHistory,
    HrdCloudMobileComment, HrdMobilePlayerDetails, HrdCloudPlayer, HrdCloudAtchFile, HrdCloudMobileHeader,
    HrdCloudRoadmapPlayList,
  },
  props: {
    objDetail: Object,
    effectNav: {
      required: false,
      type: Number,
      default: 0
    },
  },
  setup(props) {
    const store = useStore(), route = useRoute();
    const {showMessage} = useAlert();
    const isMobile = computed(() => store.state.auth.isMobile);
    const session = computed(() => store.state.auth.session);
    const sttText = ref({});
    const lrnObjDtlDistSn = computed(() => route.params.lrnObjDtlDistSn);
    const videoInstance = ref(null);
    const hrd = computed(() => props.objDetail);
    const category = ref({});
    const isMenuActive = ref(false);
    const coldcall = ref(false);
    const user = reactive({progRsltSn: 0, maxPlaySec: 0, lastPlaySec: 0, cmptnYn: 'N', mdfcnDt: null, regDt: null});
    const showModal = ref(false), historyModal = ref(false), shareModal = ref(false), opinionModal = ref(false), sttModal = ref(false);
    const histories = ref([]);
    const mainShow = computed(() => store.state.hrdcloud.main.show);
    const isFullscreen = ref(false);
    const toggleFull = change => { isFullscreen.value = change; }
    const uuid = ref(null);
    const isSeriesActive = ref(false);
    const isRoadmapListActive = ref(false);
    const roadmapSns = ref([]);

    const isPracticeModalVisible = ref(false);
    const currentPracticePoint = ref(null);

    const isAIPracticeEnabled = computed(() => {
      // -- 콘텐츠 관리번호 : 99d8fcab94f54068af25
      // select * From LMS_LRN_OBJ_DTL_DIST
      // where 1=1
      // and obj_nm = '[M365 코파일럿] 코파일럿 챗';
      // -- 348965

      const AI_PRACTICE_ENABLED_CONTENTS = ['348966']; // (PRD) [M365 코파일럿] 코파일럿 챗

      // const DEVELOPER_IDS = [ // 실 사용 전 특정 직원만 사용해보기
      //   '1653886', //강우용
      //   '3900156', //유환주
      //   '3331340', //최준원
      //   '1533872', //김귀석
      //   '3172423', //조수빈
      //   '1573509', //김영주
      //   '1630015'  //김보은
      // ]

      // console.log("hrd.value:", hrd.value);
      // console.log("lrnObjDtlDistSn:", hrd.value?.lrnObjDtlDistSn);
      // console.log("AI_PRACTICE_ENABLED_CONTENTS:", AI_PRACTICE_ENABLED_CONTENTS);
      // console.log("True of false?: ",AI_PRACTICE_ENABLED_CONTENTS.includes(String(hrd.value?.lrnObjDtlDistSn)))
      //
      // console.log("User ID:",store.state.auth.session?.lrnerId)

      // const isDeveloper = DEVELOPER_IDS.includes(store.state.auth.session?.lrnerId);
      const isEnabledContent = AI_PRACTICE_ENABLED_CONTENTS.includes(String(hrd.value?.lrnObjDtlDistSn));

      // return isDeveloper && isEnabledContent
      return isEnabledContent // 추후 실배포시 해당 리턴 사용

    });



    // PC랑 맞추기 위해 같은 객체 사용
    const popups = reactive({
      miss: {
        show: false,
        toggle: (bool) => {
          popups.miss.show = bool;
        },
        response: {
          effect: 0,
          type: null
        },
        respond: (type) => {
          popups.miss.response.effect++;
          popups.miss.response.type = type;
          popups.miss.show = false;
        },
        initRespond : () => {
          popups.miss.response.type = null;
        }
      },
      resume: {
        show: false,
        toggle: (bool) => {
          popups.resume.show = bool;
        },
        response: {
          effect: 0,
          type: null,
          continueEffect: 0,
        },
        respond: (type) => {
          popups.resume.response.effect++;
          popups.resume.response.type = type;
          popups.resume.show = false;
          if (type === 'continue') {
            popups.resume.response.continueEffect++;
          }
        },
        initRespond : () => {
          popups.resume.response.type = null;
        }
      },
      complete: {
        show: false,
        feedback: false,
        toggle: (bool) => {
           popups.complete.show = bool;
          if(!bool) popups.complete.feedback = bool;
        }
      },
      getUUID: async () => {
        const id = await generateUUID();
        if (id && id.uuid) uuid.value = id.uuid;
      }
    });

    const objectParam = computed(() => {
      return {
        distCrseSn: hrd.value.distCrseSn,
        distChapSn: hrd.value.distChapSn,
        lrnObjDtlDistSn: hrd.value.lrnObjDtlDistSn,
        objSn: hrd.value.objSn,
        // division: 'vod'
      }
    });

    // 로드맵 리스트
    const showRoadmapPlayList = (roadmapSnList) => {
      roadmapSns.value = roadmapSnList;
      isRoadmapListActive.value = true;
    }


    // AI리터러시 실습 관련
    const handlePracticePoint = (point) => {
      if (!isAIPracticeEnabled.value) return; // AI 실습이 비활성화된 경우 이벤트 무시
      // console.log('Practice Point received:', point);
      currentPracticePoint.value = point;
      isPracticeModalVisible.value = true;
      // 비디오 일시정지
      if (videoInstance.value) {
        videoInstance.value.pause();
      }
    };

    const handlePracticeComplete = () => {
      // console.log('Practice Complete, resuming video');
      isPracticeModalVisible.value = false;
      currentPracticePoint.value = null;
      //비디오 재생
      if (videoInstance.value){
        videoInstance.value.currentTime(videoInstance.value.currentTime());
        videoInstance.value.play();
      }
    };

    const handlePracticeToggle = (isActive) => {
      if (!isAIPracticeEnabled.value) return; // AI 실습이 비활성화된 경우 이벤트 무시
      // console.log('Practice Toggle:', isActive);
      if(isActive){
        // 클릭 시점 시간을 실습 포인트로 사용
        const testPoint = {
          time : Math.floor(videoInstance.value?.currentTime() || 0),
          type : 'question',
          question : '테스트용 실습 질문입니다.'
        };
        handlePracticePoint(testPoint);
      } else {
        handlePracticeComplete();
      }
    };




    // 콘텐츠 정보
    const getHrdCloudDetail = async () => {

      pageView(hrd);
      await popups.getUUID();
      getUserProgress();

      // store.dispatch(`prep/${ACT_GET_HRDCLOUD_DETAIL}`, {lrnObjDtlDistSn: lrnObjDtlDistSn.value}).then(async (res) => {
      //   if (res && res.items.length > 0) {
      //     hrd.value = res.items.map(x => {
      //       return {
      //         ...getTop1CategoryByLevel(x.cloudKeyLst),
      //         ...x,
      //         tag: makeTags(x.tag)
      //       };
      //     })[0];
      //     pageView(hrd);
      //   }
      //   await popups.getUUID();
      //   getUserProgress();
      // }).catch(e => {
      //   console.error(e);
      // });

    };
    // 사용자 진도 로그
    const getUserProgress = () => {
      getFunc(`learn/${ACT_GET_LEARN_PROGRESS}`, {
        distCrseSn: hrd.value.distCrseSn,
        lrnObjDtlDistSn: hrd.value.lrnObjDtlDistSn
      }, user);
    };

    const togglePlayerMenu = () => {
      isMenuActive.value = !isMenuActive.value;
    };

    const detailFuncs = {
      openHistory: (item) => {
        handleActions(item, videoInstance.value).actHistory(historyModal, histories,
          () => {
            showModal.value = true;
          });
      },
      openShare: (item) => {
        handleActions(item, videoInstance.value).actShare(shareModal);
      },
      openOpinion: (item) => {
        handleActions(item, videoInstance.value).actOpinion(opinionModal);
      },
      openStt: (item) => {
        handleActions(item).actStt(sttModal,sttText);

      },
      toggleScript: (item) => {
        console.log(item)
        showMessage('해당 기능은 PC에서 제공됩니다.');
      }
    };

    getHrdCloudDetail();

    watch(() => lrnObjDtlDistSn.value, () => {
      initProgressBar();
      if (lrnObjDtlDistSn.value > 0) {
        getHrdCloudDetail();
      }
    });

    watch(() => historyModal.value, () => {
      showModal.value = !showModal.value;
    });
    watch(() => shareModal.value, () => {
      showModal.value = !showModal.value;
    });
    watch(() => opinionModal.value, () => {
      showModal.value = !showModal.value;
    });
    watch(() => sttModal.value, () => {
      showModal.value = !showModal.value;
    });

    const leaderAdd = computed(() => store.state.hrdcloud.leaderAdd);

    // 담기 후 업데이트를 위해 한번 더 호출
    watch(() => leaderAdd.value.show, () => {
      if (hrd.value && !leaderAdd.value.show && leaderAdd.value.updateMyAdd) {
        const lrnObjDtlDistSn = leaderAdd.value.lrnObjDtlDistSn;
        if (hrd.value.lrnObjDtlDistSn === lrnObjDtlDistSn) {
          hrd.value.put = leaderAdd.value.isPut;
          disableMyAddChanged();
        }
      }
    });

    onMounted(() => {
      darkMode();
    });

    onBeforeUnmount(() => {
      lightMode();
      showMain();
      closeAdded();
      closeSubscribed();
      coldcall.value = false;
    });

    return {
      isMobile, session, uuid, hrd, category, coldcall, user, histories,sttText,
      videoInstance, lrnObjDtlDistSn,
      goBack,
      isMenuActive,
      togglePlayerMenu,
      timestampToDateFormat,
      handleActions, detailFuncs, detailCategoryDisplay,
      showModal, historyModal, shareModal, opinionModal, objectParam,sttModal,
      lrnObjTyCds,
      mainShow,
      popups,
      isFullscreen, toggleFull,
      isSeriesActive,
      roadmapSns,
      isRoadmapListActive,
      showRoadmapPlayList,
      isPracticeModalVisible,
      currentPracticePoint,
      isAIPracticeEnabled,
      handlePracticePoint,
      handlePracticeComplete,
      handlePracticeToggle,
    };
  }
};
</script>


<style scoped>
.ai-practice-toggle-container {
  position: fixed;
  bottom: 150px;
  right: 20px;
  z-index: 1000;
}


.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 0.4s ease;
}
.fade-scale-enter-from {
  opacity: 0;
  transform: scale(0.9);
}
.fade-scale-enter-to {
  opacity: 1;
  transform: scale(1);
}
.fade-scale-leave-from {
  opacity: 1;
  transform: scale(1);
}
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

</style>


